jQuery(function($) {
  // セレクトボックスのデフォルト文
  // $('select option[value=""]').html('----')
  // アップロードするファイルのパスを掲載
  // $('input[type=file]').on('change', 'input', function() {
  //   $('#upval').html(this.value)
  // })
  // jQuery-Validation-Engine
  const formDOM = $('.mw_wp_form,.js-validate')

  $.fn.validationEngineLanguage = function() {}
  $.validationEngineLanguage = {
    newLang: function() {
      $.validationEngineLanguage.allRules = {
        required: {
          regex: 'none',
          alertText: '必須項目です　',
          alertTextCheckboxMultiple: '選択してください　',
          alertTextCheckboxe: 'チェックボックスをチェックしてください　'
        },
        minSize: {
          regex: 'none',
          alertText: '',
          alertText2: '文字以上にしてください　'
        },
        maxSize: {
          regex: 'none',
          alertText: '',
          alertText2: '文字以下にしてください　'
        },
        min: {
          regex: 'none',
          alertText: '',
          alertText2: ' 以上の数値にしてください　'
        },
        max: {
          regex: 'none',
          alertText: '',
          alertText2: ' 以下の数値にしてください　'
        },
        past: {
          regex: 'none',
          alertText: '',
          alertText2: ' より過去の日付にしてください　'
        },
        future: {
          regex: 'none',
          alertText: '',
          alertText2: ' より最近の日付にしてください　'
        },
        maxCheckbox: {
          regex: 'none',
          alertText: 'チェックしすぎです'
        },
        minCheckbox: {
          regex: 'none',
          alertText: '',
          alertText2: 'つ以上チェックしてください　'
        },
        equals: {
          regex: 'none',
          alertText: '入力された値が一致しません　'
        },
        creditCard: {
          regex: 'none',
          alertText: '無効なクレジットカード番号です　'
        },
        phone: {
          // credit: jquery.h5validate.js / orefalo
          regex: /^([\+][0-9]{1,3}[ \.\-])?([\(]{1}[0-9]{2,6}[\)])?([0-9 \.\-\/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/,
          alertText: '電話番号が正しくありません　'
        },
        email: {
          /* eslint-disable-next-line */
          regex: /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i,
          alertText: 'メールアドレスが正しくありません　'
        },
        integer: {
          regex: /^[\-\+]?\d+$/,
          alertText: '整数を半角で入力してください　'
        },
        number: {
          // Number, including positive, negative, and floating decimal. credit: orefalo
          regex: /^[\-\+]?((([0-9]{1,3})([,][0-9]{3})*)|([0-9]+))?([\.]([0-9]+))?$/,
          alertText: '数値を半角で入力してください　'
        },
        date: {
          regex: /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/,
          alertText: '日付は半角で YYYY-MM-DD の形式で入力してください　'
        },
        ipv4: {
          regex: /^((([01]?[0-9]{1,2})|(2[0-4][0-9])|(25[0-5]))[.]){3}(([0-1]?[0-9]{1,2})|(2[0-4][0-9])|(25[0-5]))$/,
          alertText: 'IPアドレスが正しくありません　'
        },
        url: {
          regex: /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i,
          alertText: 'URLが正しくありません　'
        },
        onlyNumberSp: {
          regex: /^[0-9\ ]+$/,
          alertText: '半角数字で入力してください　'
        },
        onlyLetterSp: {
          regex: /^[a-zA-Z\ \']+$/,
          alertText: '半角アルファベットで入力してください　'
        },
        onlyLetterNumber: {
          regex: /^[0-9a-zA-Z]+$/,
          alertText: '半角英数で入力してください　'
        },
        // --- CUSTOM RULES -- Those are specific to the demos, they can be removed or changed to your likings
        ajaxUserCall: {
          url: 'ajaxValidateFieldUser',
          // you may want to pass extra data on the ajax call
          extraData: 'name=eric',
          alertText: 'This user is already taken',
          alertTextLoad: 'Validating, please wait'
        },
        ajaxNameCall: {
          // remote json service location
          url: 'ajaxValidateFieldName',
          // error
          alertText: 'This name is already taken',
          // if you provide an "alertTextOk", it will show as a green prompt when the field validates
          alertTextOk: 'This name is available',
          // speaks by itself
          alertTextLoad: 'Validating, please wait'
        },
        validate2fields: {
          alertText: '『HELLO』と入力してください'
        }
      }
    }
  }
  $.validationEngineLanguage.newLang()

  const blankError = {
    message: '　'
  }
  const customError = {
    '.validate[required,custom[integer],min[50],max[386]]': {
      required: blankError
    },
    '.validate[required,custom[integer],min[50],max[490]]': {
      required: blankError
    },
    '.validate[required,minSize[8]]': {
      required: blankError
    },
    '.validate[required,equals[reg-pass1],minSize[8]]': {
      required: blankError
    },
    '.validate[required,custom[phone]]': {
      required: blankError
    },
    '.validate[required,custom[email]]': {
      required: blankError
    },
    '.validate[required,custom[email],equals[mail]]': {
      required: blankError
    },
    '.validate[required,custom[email],equals[reg-mail1]]': {
      required: blankError
    }
  }

  $('[name^="ok"]').attr('data-errormessage', '同意の上チェックしてください')
  formDOM.find('form').validationEngine({
    scrollOffset: 200,
    custom_error_messages: customError
  })

  // jQuery-Validation-Engine for MW WP Form
  /*
  必須入力
  validate【required】
  指定の書式
  validate【custom【email】】
  validate【custom【phone】】
  validate【custom【url】】
  custom【date】
  指定IDと入力内容が一致
  validate【equals【id】】
  指定IDがチェック済みなら必須入力に変更
  validate【condRequired【id】】
  指定範囲の文字数
  validate【maxSize【10】】
  validate【minSize【10】】
  整数のみ
  validate【custom【integer】】
  数字のみ
  validate【custom【number】】
  英数字のみ
  validate【custom【onlyLetterNumber】】
  英字と空白のみ
  validate【custom【onlyLetterSp】】
  数字と空白のみ
  validate【custom【onlyNumberSp】】
  指定範囲の数値
  validate【min【-5】】
  validate【max【30】】
  指定範囲の日付
  validate【custom【date】,past【2010/01/01】】
  validate【custom【date】,future【NOW】】
  チェックボックスのチェック数
  validate【minCheckbox【2】】
  validate【maxCheckbox【2】】
  */
  formDOM.find('input,textarea,select').each(function() {
    var domclass = $(this).attr('class')
    if (domclass) {
      domclass = domclass.replace(/【/g, '[').replace(/】/g, ']') // ショートコード誤認回避の【】を[]に戻す
      $(this).attr('class', domclass)
    }
  })
  $(window).on('load scroll resize focus blur click ', function() {
    $('input[type="submit"]').removeAttr('disabled') // MW側のSubmit禁止処理を外す
  })

  // PrettyBox for MW WP Form
  /*
  クラスは公式ドキュメントで調べる
  https://lokesh-coder.github.io/pretty-checkbox/
  */
  // $('.mwform-checkbox-field').each(function() {
  //   $(this).addClass('pretty p-default p-thick p-pulse') // チェックボックスをPrettyBoxに変更
  //   $(this)
  //     .find('.mwform-checkbox-field-text')
  //     .unwrap()
  //     .wrap('<div class="state p-danger-o"><label></label></div>') // MWのlabelを剥がしてPBox用MWのlabelを貼り直す
  // })
  // $('.mwform-radio-field').each(function() {
  //   $(this).addClass('pretty p-default p-round p-thick p-pulse') // ラジオボタンをPrettyBoxに変更
  //   $(this)
  //     .find('.mwform-radio-field-text')
  //     .unwrap()
  //     .wrap('<div class="state p-danger-o"><label></label></div>') // MWのlabelを剥がしてPBox用MWのlabelを貼り直す
  // })

  // 電話番号、郵便番号最適化
  $('input[name="tel"],input[name="phone"]').on('input', function() {
    // 数字系データを整理
    var txt = $(this).val()
    var han = txt.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
      // 半角変換
      return String.fromCharCode(s.charCodeAt(0) - 0xfee0)
    })
    han = han.replace(/[〒－\- 　]/gi, '') // ハイフン、郵便マーク除去
    $(this).val(han)
  })

  // メールアドレス最適化
  // $('input[name="email"],input[name="email1"],input[name="email2"]').on('input change click keyup paste', function() {
  //   // メールアドレスを半角変換
  //   var txt = $(this).val()
  //   var han = txt.replace(/[Ａ-Ｚａ-ｚ０-９＠－．]/g, function(s) {
  //     // 半角変換
  //     return String.fromCharCode(s.charCodeAt(0) - 0xfee0)
  //   })
  //   $(this).val(han)
  // })

  /*
       ######## ########  ########   #######  ########
       ##       ##     ## ##     ## ##     ## ##     ##
       ##       ##     ## ##     ## ##     ## ##     ##
       ######   ########  ########  ##     ## ########
       ##       ##   ##   ##   ##   ##     ## ##   ##
       ##       ##    ##  ##    ##  ##     ## ##    ##
       ######## ##     ## ##     ##  #######  ##     ##
*/
  // エラー装飾
  errorCheck()
  function errorCheck() {
    // プレースホルダーの書き換えとクリック解除用クラス
    $('.isError').each(function() {
      const item = $(this)
      const error = item.attr('data-error')
      item.attr('placeholder', error).addClass('js-error')
    })
  }

  // クリックでエラー装飾解除
  $(document).on(' click input ', '.js-error', function() {
    const item = $(this)
    const placeholder = item.attr('data-placeholder')
    item.attr('placeholder', placeholder).removeClass('js-error isError')
    if (item.hasClass('checkError-group')) {
      const group = item.attr('data-group')

      $('.checkError--' + group).removeClass('js-error isError')
    }
  })

  /*
       ########  ########   #######   ######   ########  ########  ######   ######
       ##     ## ##     ## ##     ## ##    ##  ##     ## ##       ##    ## ##    ##
       ##     ## ##     ## ##     ## ##        ##     ## ##       ##       ##
       ########  ########  ##     ## ##   #### ########  ######    ######   ######
       ##        ##   ##   ##     ## ##    ##  ##   ##   ##             ##       ##
       ##        ##    ##  ##     ## ##    ##  ##    ##  ##       ##    ## ##    ##
       ##        ##     ##  #######   ######   ##     ## ########  ######   ######
*/
  // 簡単見積 Standard　ご入力完了項目数
  const progressForm = $('#standardFrom')
  const progressSubmit = $('.js-validate--submit')
  const progressValidate = progressForm.validationEngine({
    // scrollOffset: 200,
    scroll: false,
    focusFirstField: false,
    custom_error_messages: customError
  })

  // 計測用のエラー出力を消す判定
  let alertLock = false

  function validateCount(thisDOM = false) {
    if (progressValidate.validationEngine('validate')) {
      // エラーがなければ0
      $('#progress').text(0)
      progressSubmit.attr('disabled', false)
    } else {
      // エラーがあればカウント
      const errorDOM = progressForm.find('.formError')
      const total = errorDOM.length
      if (!alertLock) {
        errorDOM.remove()
      }
      // console.log(total)
      $('#progress').text(total)
      progressSubmit.attr('disabled', 'disabled')
      if (thisDOM) {
        thisDOM.validationEngine('validate')
      }
    }
  }
  if (document.getElementById('progress')) {
    validateCount()
    progressForm.find('input,select,textarea').on('change', function(event) {
      validateCount($(this))
    })
    progressForm.find('button').on('click', function(event) {
      alertLock = true
    })
    progressForm.find('.js-validate--off').on('click', function(event) {
      progressForm.validationEngine('detach')
    })
    // Enterによる送信を無効化
    $('input[type="text"]').on('keydown', function(e) {
      if ((e.which && e.which === 13) || (e.keyCode && e.keyCode === 13)) {
        return false
      } else {
        return true
      }
    })
  }

  /*
               ########  ######## ########  ##     ##  ######
               ##     ## ##       ##     ## ##     ## ##    ##
               ##     ## ##       ##     ## ##     ## ##
       ####### ##     ## ######   ########  ##     ## ##   ####
               ##     ## ##       ##     ## ##     ## ##    ##
               ##     ## ##       ##     ## ##     ## ##    ##
               ########  ######## ########   #######   ######
*/
  // デバッグ用処理
  if (location.hash.match(/#--debug-error/)) {
    // ハッシュを検出したら実行
    $('[class^="validate["],.checkError').addClass('isError')
    errorCheck()
  }
})
